module.exports = __webpack_public_path__ + "static/img/tky-kcbg5-nor@2x.e5334f76.png";